module.exports = __webpack_public_path__ + "img/w55.a0c3161e.svg";